import { useState, useEffect, useCallback } from 'react';

const useGridDimensions = (initialPaddingX = 100, initialPaddingY = 250, cardWidth = 350, cardGap = 24) => {
  const [gridHeight, setGridHeight] = useState(window.innerHeight - initialPaddingY);
  const [gridWidth, setGridWidth] = useState(window.innerWidth - initialPaddingX);
  const [columnCount, setColumnCount] = useState(2); // Default number of columns

  // Calculate dimensions and column count based on window size
  const calculateDimensions = useCallback(() => {
    const width = window.innerWidth - initialPaddingX;
    setGridWidth(width);
    setGridHeight(window.innerHeight - initialPaddingY);
    
    // Calculate how many columns can fit based on available width
    const totalCardWidth = cardWidth + cardGap;
    const columns = Math.max(1, Math.floor(width / totalCardWidth));
    setColumnCount(columns);
  }, [initialPaddingX, initialPaddingY, cardWidth, cardGap]);

  // Handle window resize
  useEffect(() => {
    // Initial calculation
    calculateDimensions();

    // Add event listener for window resize
    window.addEventListener('resize', calculateDimensions);
    
    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', calculateDimensions);
  }, [calculateDimensions]);

  // Calculate the cell width based on grid width and column count
  const cellWidth = Math.floor(gridWidth / columnCount);

  return {
    gridHeight,
    gridWidth,
    columnCount,
    cellWidth,
    calculateDimensions
  };
};

export default useGridDimensions; 